var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({staticClass:"descriptionList",class:_vm.size},'div',_vm.restProps,false),[(_vm.title)?_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('a-row',{attrs:{"gutter":32}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }